import { render, staticRenderFns } from "./WeChatInterests.vue?vue&type=template&id=58dde92c&scoped=true&"
import script from "./WeChatInterests.vue?vue&type=script&lang=js&"
export * from "./WeChatInterests.vue?vue&type=script&lang=js&"
import style0 from "./WeChatInterests.vue?vue&type=style&index=0&id=58dde92c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dde92c",
  null
  
)

export default component.exports